// import React, { useState } from 'react';
// import clsx from 'clsx';
// import { Row } from 'react-table';
// import { useModule } from '../../../hooks/module/useModule';

// interface ClientProfileModulesTableBodyProps<T extends object> {
//   table: {
//     getTableBodyProps: () => any;
//     rows: Row<T>[];
//     prepareRow: (row: Row<T>) => void;
//     columns: any[];
//   };
//   getExpandedComponent?: (
//     row: T,
//     detail?: any,
//     menus?: any[],
//     roles?: string[]
//   ) => React.ReactNode;
//   noDataMessage?: string;
//   enableRowClick?: boolean;
//   moduleMenus?: Record<number, any[]>;
//   moduleRoles?: Record<number, string[]>;
// }

// const ClientProfileModulesTableBody = <T extends { id: number }>({
//   table,
//   getExpandedComponent,
//   noDataMessage = 'No hay módulos disponibles.',
//   enableRowClick,
//   moduleMenus = {},
//   moduleRoles = {},
// }: ClientProfileModulesTableBodyProps<T>) => {
//   const { getTableBodyProps, rows, prepareRow, columns } = table;
//   const [expandedRowId, setExpandedRowId] = useState<number | null>(null);
//   const { moduleDetail, fetchModuleDetail, clearDetail } = useModule();

//   const handleRowClick = async (rowIndex: number, moduleId: number) => {
//     setExpandedRowId((prev) => {
//       if (prev === rowIndex) {
//         console.log('🔻 Cerrando módulo:', moduleId);
//         clearDetail();
//         return null;
//       } else {
//         console.log('🔺 Abriendo módulo:', moduleId);
//         fetchModuleDetail(moduleId);
//         return rowIndex;
//       }
//     });
//   };

//   return (
//     <tbody {...getTableBodyProps()}>
//       {rows.length > 0 ? (
//         rows.map((row, index) => {
//           prepareRow(row);
//           const isExpanded = expandedRowId === index;
//           const moduleId = (row.original as any).id;

//           const detail =
//             moduleDetail && moduleDetail.id === moduleId ? moduleDetail : undefined;
//           const menus = moduleMenus[moduleId] || [];
//           const roles = moduleRoles[moduleId] || [];

//           return (
//             <React.Fragment key={row.id || index}>
//               <tr
//                 {...row.getRowProps()}
//                 className={clsx(
//                   'hover:bg-gray-50 dark:hover:bg-gray-700 transition',
//                   enableRowClick && 'cursor-pointer'
//                 )}
//                 onClick={
//                   enableRowClick
//                     ? () => handleRowClick(index, moduleId)
//                     : undefined
//                 }
//               >
//                 {row.cells.map((cell, cellIndex) => {
//                   const isLastColumn = cellIndex === row.cells.length - 1;
//                   return (
//                     <td
//                       {...cell.getCellProps()}
//                       className="text-gray-900 dark:text-gray-200 border px-4 py-2"
//                     >
//                       <div className="flex items-center justify-between">
//                         {cell.render('Cell')}
//                         {getExpandedComponent && isLastColumn && (
//                           <svg
//                             className={clsx(
//                               'text-gray-400 ml-2 h-4 w-4 fill-current transition-transform duration-200',
//                               isExpanded ? 'rotate-180' : ''
//                             )}
//                             viewBox="0 0 24 24"
//                           >
//                             <path d="M12 15.5l-8-8 1.41-1.42L12 12.67l6.59-6.59L20 7.5z" />
//                           </svg>
//                         )}
//                       </div>
//                     </td>
//                   );
//                 })}
//               </tr>

//               {/* Fila expandida */}
//               {isExpanded && getExpandedComponent && (
//                 <tr>
//                   <td colSpan={columns.length} className="bg-gray-50 px-4 py-4">
//                     {getExpandedComponent(row.original, detail, menus, roles)}
//                   </td>
//                 </tr>
//               )}
//             </React.Fragment>
//           );
//         })
//       ) : (
//         <tr>
//           <td
//             colSpan={columns.length}
//             className="text-gray-500 border px-4 py-4 text-center"
//           >
//             {noDataMessage}
//           </td>
//         </tr>
//       )}
//     </tbody>
//   );
// };

// export default ClientProfileModulesTableBody;

import React, { useState } from 'react';
import clsx from 'clsx';
import { Row } from 'react-table';
import { useModule } from '../../../hooks/module/useModule';

interface ClientProfileModulesTableBodyProps<T extends object> {
  table: {
    getTableBodyProps: () => any;
    rows: Row<T>[];
    prepareRow: (row: Row<T>) => void;
    columns: any[];
  };
  getExpandedComponent?: (
    row: T,
    detail?: any,
    menus?: any[],
    roles?: string[]
  ) => React.ReactNode;
  noDataMessage?: string;
  enableRowClick?: boolean;
  moduleMenus?: Record<number, any[]>;
  moduleRoles?: Record<number, string[]>;
}

const ClientProfileModulesTableBody = <T extends { id: number }>({
  table,
  getExpandedComponent,
  noDataMessage = 'No hay módulos disponibles.',
  enableRowClick,
  moduleMenus = {},
  moduleRoles = {},
}: ClientProfileModulesTableBodyProps<T>) => {
  const { getTableBodyProps, rows, prepareRow, columns } = table;
  const [expandedRowId, setExpandedRowId] = useState<number | null>(null);
  const { moduleDetail, fetchModuleDetail, clearDetail } = useModule();

  const handleRowClick = async (rowIndex: number, moduleId: number) => {
    setExpandedRowId((prev) => {
      if (prev === rowIndex) {
        clearDetail();
        return null;
      } else {
        fetchModuleDetail(moduleId);
        return rowIndex;
      }
    });
  };

  return (
    <tbody {...getTableBodyProps()}>
      {rows.length > 0 ? (
        rows.map((row, index) => {
          prepareRow(row);
          const isExpanded = expandedRowId === index;
          const moduleId = (row.original as any).id;

          const detail =
            moduleDetail && moduleDetail.id === moduleId ? moduleDetail : undefined;
          const menus = moduleMenus[moduleId] || [];
          const roles = moduleRoles[moduleId] || [];

          // ✅ Extraemos key de row.getRowProps()
          const { key: rowKey, ...rowRest } = row.getRowProps();

          return (
            <React.Fragment key={rowKey}>
              <tr
                {...rowRest}
                className={clsx(
                  'hover:bg-gray-50 dark:hover:bg-gray-700 transition',
                  enableRowClick && 'cursor-pointer'
                )}
                onClick={
                  enableRowClick
                    ? () => handleRowClick(index, moduleId)
                    : undefined
                }
              >
                {row.cells.map((cell, cellIndex) => {
                  const isLastColumn = cellIndex === row.cells.length - 1;

                  // ✅ Extraemos key también para la celda
                  const { key: cellKey, ...cellRest } = cell.getCellProps();

                  return (
                    <td
                      key={cellKey}
                      {...cellRest}
                      className="text-gray-900 dark:text-gray-200 border px-4 py-2"
                    >
                      <div className="flex items-center justify-between">
                        {cell.render('Cell')}

                        {getExpandedComponent && isLastColumn && (
                          <svg
                            className={clsx(
                              'text-gray-400 ml-2 h-4 w-4 fill-current transition-transform duration-200',
                              isExpanded ? 'rotate-180' : ''
                            )}
                            viewBox="0 0 24 24"
                          >
                            <path d="M12 15.5l-8-8 1.41-1.42L12 12.67l6.59-6.59L20 7.5z" />
                          </svg>
                        )}
                      </div>
                    </td>
                  );
                })}
              </tr>

              {isExpanded && getExpandedComponent && (
                <tr>
                  <td colSpan={columns.length} className="bg-gray-50 px-4 py-4">
                    {getExpandedComponent(row.original, detail, menus, roles)}
                  </td>
                </tr>
              )}
            </React.Fragment>
          );
        })
      ) : (
        <tr>
          <td
            colSpan={columns.length}
            className="text-gray-500 border px-4 py-4 text-center"
          >
            {noDataMessage}
          </td>
        </tr>
      )}
    </tbody>
  );
};

export default ClientProfileModulesTableBody;
